import React from "react";
import { useNavigate } from "react-router-dom"

// export function GiftCardsButton ({ text, navigateTo }) {
//   const navigate = useNavigate();
//   const handleClick = () => {
//     navigate(navigateTo);
//   }
//   return (
//     <div className="bg-white flex items-center mx-auto w-full max-w-4xl justify-center fixed bottom-0 left-0 right-0 p-4 overflow-hidden border-t-[1px] border-[#F2F4F5]">
//       <button className="border-2 border-[#00ADEF] w-full px-6 py-3 rounded-[8px] bg-[#00ADEF] sm:text-[12px] lg:text-[14px] font-[600] text-[#FFFFFF] text-center hover:opacity-60 font-poppins"
//       onClick={() => handleClick()}>
//         {text}
//       </button>
//     </div>
//   );
// };
export function GiftCardsButton({ text, navigateTo }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (typeof navigateTo === "string") {
      navigate(navigateTo);
    } else if (typeof navigateTo === "object" && navigateTo.pathname) {
      navigate(navigateTo.pathname, { state: navigateTo.state });
    }
  };

  return (
    <div className="bg-white flex items-center mx-auto w-full max-w-4xl justify-center fixed bottom-0 left-0 right-0 p-4 overflow-hidden border-t-[1px] border-[#F2F4F5]">
      <button
        className="border-2 border-[#00ADEF] w-full px-6 py-3 rounded-[8px] bg-[#00ADEF] sm:text-[12px] lg:text-[14px] font-[600] text-[#FFFFFF] text-center hover:opacity-60 font-poppins"
        onClick={handleClick}
      >
        {text}
      </button>
    </div>
  );
}


export function NextandBackGiftCardButton({
  onNext,
  onBack,
  nextText = "Next",
  backText = "Back",
  showBack = true,
  showNext = true,
}) {
  const navigate = useNavigate();

  // Default Back Handler
  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1); // fallback to browser back
    }
  };

  // Default Next Handler
  const handleNext = () => {
    if (onNext) {
      onNext();
    } else {
      console.log("Next clicked");
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t-[1px] border-[#F2F4F5] p-4">
      <div className="max-w-4xl mx-auto">
        <div className="grid grid-cols-2 gap-4">
          {showBack && (
            <button
              onClick={handleBack}
              // className="px-6 py-3 border-2 border-[#00ADEF] text-[#00ADEF] hover:opacity-60 font-semibold transition-colors rounded-lg font-poppins"
             className="px-6 py-3 border border-[#00ADEF] text-[#00ADEF] hover:opacity-60 font-semibold transition-colors rounded-lg font-poppins"
   >
              {backText}
            </button>
          )}

          {showNext && (
            <button
              onClick={handleNext}
              className="px-6 py-3 bg-[#00ADEF] text-white font-semibold hover:opacity-60 transition-colors rounded-lg font-poppins"
            >
              {nextText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
